import axios from "axios";

var instance = axios.create({
  baseURL: "http://api.iky001.com/api/gateway", //接口统一域名
  timeout: 30000, //设置超时
});

instance.interceptors.request.use(
  function(config) {
    config.headers.Token = getToken();
    config.headers.Language = getLanguage();
    return config;
  },
  function(error) {
    // 对请求错误做些什么
    return Promise.reject(error);
  }
);

// 添加响应拦截器
instance.interceptors.response.use(
  function(response) {
    // 对响应数据做点什么
    return response;
  },
  function(error) {
    // 对响应错误做点什么
    return Promise.reject(error);
  }
);

export var api = {
  get: function(name, params) {
    return new Promise((resolve, reject) => {
      instance
        .get(name, {
          params,
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err.data);
        });
    });
  },
  post: function(name, params) {
    return new Promise((resolve, reject) => {
      instance
        .post(name, params)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
};

export var config = {
  set: function(key, value) {
    if (value !== undefined) {
      localStorage.setItem(key, JSON.stringify(value));
    }
  },
  get: function(key) {
    if (!localStorage.getItem(key)) {
      return "";
    } else {
      if (localStorage.getItem(key) === undefined) {
        return "";
      } else {
        return JSON.parse(localStorage.getItem(key));
      }
    }
  },
  remove: function(key) {
    localStorage.removeItem(key);
  },
  clear: function() {
    localStorage.clear();
  },
};

export var session = {
  set: function(key, value) {
    sessionStorage.setItem(key, JSON.stringify(value));
  },
  get: function(key) {
    if (!sessionStorage.getItem(key)) {
      return "";
    } else {
      if (sessionStorage.getItem(key) === undefined) {
        return "";
      } else {
        try {
          return JSON.parse(sessionStorage.getItem(key));
        } catch (error) {
          return "";
        }
      }
    }
  },
  remove: function(key) {
    sessionStorage.removeItem(key);
  },
  clear: function() {
    sessionStorage.clear();
  },
};

let getToken = function() {
  return config.get("token");
};

let getLanguage = function() {
  return session.get("language");
};

export default {};
